import type {FlexSuiteCategoryPage} from '../types'
import {FlexSuiteSubNav} from '../components/FlexSuiteSubNav'

export type CategoryTemplateProps = {
  page: FlexSuiteCategoryPage
}

export function CategoryTemplate({page}: CategoryTemplateProps) {
  const {template} = page.fields

  return <>{template.fields.subNav && <FlexSuiteSubNav subNav={template.fields.subNav} />}</>
}
